export const authTaxonomyObject = {
    google: {
        signin: {
            signed_in_status: 'signed in',
            registration_platform: 'google'
        },
        register: {
            signed_in_status: 'signed in',
            registration_platform: 'google'
        }
    },
    facebook: {
        signin: {
            signed_in_status: 'signed in',
            registration_platform: 'facebook'
        },
        register: {
            signed_in_status: 'signed in',
            registration_platform: 'facebook'
        }
    },
    zpg: {
        signin: {
            signed_in_status: 'signed in',
            registration_platform: 'ZPG'
        },
        register: {
            signed_in_status: 'signed in',
            registration_platform: 'ZPG'
        }
    }
};
